/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'personal-info-acm',
  template: require('./personal-info-acm.component.html')
})
export class PersonalInfoACMComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
    const personalInfo = this.appActions.getData('PersonalInformation', {});
    const yourInfo = this.appActions.getData('YourInformation', {});

    this.maritalStatusLocal = personalInfo.maritalStatus;

    if (this.flowManager.isAuthed && personalInfo.ssn != null && personalInfo.dob != null) {
      this.form.inputs.ssn.labelPosition = 'leftMask';
      this.form.inputs.dob.labelPosition = 'leftMask';
      this.form.inputs.ssn.attr.classes = 'col s12 m5 padding-top-6';
      this.form.inputs.dob.attr.classes = 'col s12 m5 padding-top-6';
    }

    // Redux check to see if prepop failed
    const prepopFailed = this.appActions.getData('prepopFailed', false);
    if (yourInfo.firstName == null || yourInfo.lastName == null || prepopFailed) {
      this.form.inputs.firstName.showUp = true;
      this.form.inputs.firstName.require = true;
      this.form.inputs.middleInitial.showUp = true;
      this.form.inputs.lastName.showUp = true;
      this.form.inputs.lastName.require = true;
      this.form.inputs.email.showUp = true;
      this.form.inputs.email.require = true;
      this.appActions.setData('prepopFailed', true);
    }

    // Check for existing customer to hide security question/answer
    if (this.flowManager.isTkCustomer === true) {
      this.form.inputs.securityQuestion.showUp = false;
      this.form.inputs.securityQuestion.require = false;
      this.form.inputs.securityAnswer.showUp = false;
      this.form.inputs.securityAnswer.require = false;
    }
  }

  ngOnInit() {
    const steps = this.flowManager.getStepArrays('personal-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    if (this.flowManager.promoCode === false) {
      delete this.form.inputs.promoCode;
    } else {
      this.form.inputs.promoCode.noneditable = this.flowManager.promoCode;
      this.appActions.setData('PersonalInformation.promoCode', this.flowManager.promoCode);
    }
  }

  btnClick(e) {
    if (e.action === 'next') {
      if (!this.flowManager.isAuthed) {
        this.modal.loadingModel();
        
        const personalInfo = this.appActions.getData('PersonalInformation', {});
        const yourInfo = this.appActions.getData('YourInformation', {});
        const payload = {
          lastName: yourInfo.lastName,
          dateOfBirth: personalInfo.dob,
          identificationNumber: personalInfo.ssn
        };
        this.appProxy.custFuzzySearch(payload, resp => {
          if (resp.matchFound && resp.matchFound === true) {
            this.modal.refreshModal({
              modalType: 'login',
              fukTopRight: 'false',
              modalClass: 'modal-login',
              title: 'It looks like you are an existing customer. Log in with your Ally credentials to proceed.',
              body: '',
              buttons: []
            });
          } else {
            const nextRoute = this.getActionRoute(e.action);
            this.modal.closeModal(nextRoute);
            return;
          }
        });
        return;
      }
    }

    this.handleClick(e.action);
  }
}
